export default __webpack_public_path__ + "static/media/Ellipse_3.1f628a02.png";